<template>
<div class="data-item border">
  <div class="data-item-header">
    <span>{{data.deviceName}}</span>
    <div class="toolbar">
      <el-button v-if="showUnmatchedBtn" type="success" size="mini" @click="onNotMatchBtnClick">未匹配因子</el-button>
      <el-select v-model="chartType" size="mini" @change="readyRenderChart">
        <el-option label="默认图表" :value="qcType ? qcType.chartType : ''" />
        <el-option label="箱式图表" value="boxplot" />
      </el-select>
    </div>
  </div>
  <div class="chart-wrapper">
    <div
      v-for="(category, index) in categories"
      v-show="vShow[index]"
      :key="index"
      style="position:relative;width:100%;padding-bottom:30px;"
    >
      <div class="chart-wrapper-inner">
        <e-chart ref="chart" :style="{width:chartWidth}" style="min-width:100%;height:328px;" />
      </div>

      <div class="limit-input-wrapper">
        <span style="font-size:.7em;display:inline-block;line-height:28px;vertical-align:middle;">控制限值:</span>
        <el-input
          v-model="limit"
          placeholder="控制限值"
          type="number"
          size="mini"
          style="width:100px;"
          @change="onLimitChange"
          @keydown.native.enter="onLimitChange"
        />
      </div>
    </div>

    <div style="margin-top:20px">
      <nonconformity-chart
        v-if="qcType.statistics"
        :qc-type="qcType"
        :date-range="dateRange"
        :summaries="summaries"
      />
<!--      <div v-else-if="qcType.getSummaryList" class="summary-wrapper">-->
<!--        <div-->
<!--          v-for="summary in summaries"-->
<!--          :key="summary.dataTime"-->
<!--        >-->
<!--          <div>{{summary.dataTime}}</div>-->
<!--          <div>-->
<!--            <div-->
<!--              v-for="(summaryItem, index) in summary.list"-->
<!--              :key="index"-->
<!--            >{{summaryItem}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-else class="summary-wrapper">-->
      <div class="summary-wrapper">
        <div v-if="(categories || []).length < 2">控制限值：{{qcType.ctrlType === 3 ? '±' : qcType.ctrlType === 1 ? '-' : ''}}{{isNaN(realLimit) ? '--' : realLimit}}{{qcType.unit}}</div>
        <div
          v-for="summary in summaries"
          :key="summary.dataTime"
        >
          <span>{{summary.dataTime}}：超出范围{{summary.error}}个</span>
          <span v-if="summary.hasKeyComponent">(关键物钟{{summary.errorFactorIds.length}}个)</span>
          <span>，占比{{(summary.error / summary.total * 100).toFixed(2)}}%</span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import chartsUtils from '../../../components/Charts/chartsUtils'

import NonconformityChart from './NonconformityChart'
import {mapGetters} from 'vuex'

const CTRL_LINE_MAP = {
  '-1': 'LCL',
  1: 'UCL'
}

export default {
  name: 'QCChart',
  components: {
    NonconformityChart
  },
  props: {
    data: {
      required: true,
      type: Object
    },
    qcDevice: {
      required: true,
      type: Object
    },
    qcType: {
      required: true,
      type: Object
    },
    dateRange: Array,
    site: Object,
    showUnmatchedBtn: {
      required: true,
      type: Boolean
    }
  },
  data () {
    let defaultCtrlVal = this.qcType.defaultCtrlVal

    return {
      limit: defaultCtrlVal,
      realLimit: defaultCtrlVal,
      chartWidth: '100%',
      categories: Object.freeze([[]]),
      deviceCategoryMap: {},
      chartType: '',
      vShow: [true, true]
    }
  },
  computed: {
    ...mapGetters({
      factorGroupMap: 'FactorGroup/map',
      keyComponentIdMap: 'Factor/keyComponentIdMap'
    }),
    summaries () {
      let {realLimit, qcType: {getFlag}, keyComponentIdMap} = this
      return (this.data.data || []).map(({dataTime, data}) => {
        let dataList = Object.entries(data)
        let errorFactorIds = []

        return {
          dataTime,
          error: dataList.reduce((count, [factorId, value]) => {
            let flag = (!Number.isFinite(value) || getFlag(value, realLimit))

            if (flag && keyComponentIdMap[factorId]) {
              errorFactorIds.push(factorId)
            }

            return count + flag
          }, 0),
          total: dataList.length,
          errorFactorIds,
          hasKeyComponent: dataList.some(([factorId]) => keyComponentIdMap[factorId])
        }
      })
    }
  },
  methods: {
    renderChart (data, chart, realLimit, chartOpts = {}) {
      let {qcType, chartType} = this
      let {ctrlType} = qcType
      let {factors, data: dataList} = data
      let tooltip = {
        trigger: 'axis',
        appendToBody: true,
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: 'rgba(0, 0, 0, .5)'
          }
        }
      }

      let series

      if (chartType === 'boxplot') {
        series = [{
          name: '箱形图',
          type: chartType,
          data: chartsUtils.prepareBoxplotData(factors.map(factor => dataList.map(data => data.data[factor.factorId || factor.name]).filter(n => Number.isFinite(n)))).boxData.map(data => data.map(n => Number(n.toFixed(2)))),
          markArea: chartOpts.markArea
        }, {
          name: '平均值',
          type: 'scatter',
          data: factors.map((factor, index) => {
            let filterDataList = dataList.map(data => data.data[factor.factorId || factor.name]).filter(n => Number.isFinite(n))
            return Number((filterDataList.reduce((count, n) => count + n, 0) / filterDataList.length).toFixed(2))
          }),
          symbolSize: 4
        }]
      } else {
        series = dataList.map(({dataTime, data}, index) => ({
          name: dataTime,
          type: chartType,
          data: factors.map(factor => data[factor.factorId || factor.name]),
          symbolSize: 4,
          markArea: index === 0 ? chartOpts.markArea : undefined
        }))

        tooltip.formatter = params => {
          const E_CHART_MAX_ROWS = process.env.E_CHART_MAX_ROWS
          let columns = Math.ceil(params.length / E_CHART_MAX_ROWS)
          let add = 1
          return `<div class="e-chart-tooltip" style="--e-chart-tooltip-columns:${columns}"><div class="e-chart-tooltip-name">${params[0].name}</div><div class="e-chart-tooltip-content">${params.map(({marker, seriesName, value, seriesId, data}, index) => `<span class="ucl-lcl" series-name="${seriesName}">${marker}</span><span class="e-chart-tooltip-series-name">${seriesName}:</span><span class="e-chart-tooltip-value ${((index + add) % columns) === 0 ? '' : 'e-chart-tooltip-value-space'}">${Number.isFinite(value) ? value : '--'}</span>`).join('')}</div></div>`
        }
      }

      let yAxisConfig = {
        scale: true
      }

      if (ctrlType < 3) {
        let data = dataList.map(data => Object.values(data.data)).flat().filter(n => n !== null)
        let max = Math.max(...data)
        let min = Math.min(...data)

        if (max === min || realLimit <= min) {
          yAxisConfig.boundaryGap = ['30%', 0]
        }
      }

      while (ctrlType > 0) {
        let n = -ctrlType & ctrlType
        ctrlType ^= n
        n = (n - 2) | 1

        let clVal = realLimit * n
        let chartData = {
          name: CTRL_LINE_MAP[n],
          type: 'line',
          data: factors.map(() => clVal),
          color: 'rgba(0,0,0,0)',
          symbol: 'none',
          lineStyle: {
            type: 'dashed',
            width: 1
          },
          markLine: {
            data: [{
              name: CTRL_LINE_MAP[n],
              yAxis: clVal
            }],
            lineStyle: {
              color: 'red'
            },
            precision: 6
          }
        }

        series.unshift(chartData)
      }

      let ctrlLineList = Object.values(CTRL_LINE_MAP)
      let chartOpt = {
        title: {
          text: `${this.qcDevice.label} ${qcType.label}`,
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontFamily: 'simsun',
            color: '#284070'
          },
          subtextStyle: {
            fontFamily: 'simsun'
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip,
        legend: {
          data: series.filter(seriesItem => ctrlLineList.indexOf(seriesItem.name) === -1).map(seriesItem => seriesItem.name),
          top: 35,
          left: 'center',
          textStyle: {
            padding: [3, 0, 3, 0],
            fontFamily: 'Times New Roman'
          },
          type: 'scroll'
        },
        grid: {
          top: 80,
          right: 40,
          bottom: 0,
          left: 0,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: factors.map(factor => factor.name),
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            interval: 0,
            rotate: 90,
            textStyle: {
              color: '#000'
            },
            formatter: name => name.replace(/\s+-\s+(TO14|PAMS)$/i, '')
          },
          splitLine: chartOpts.splitLine
        }],
        yAxis: {
          type: 'value',
          // boundaryGap: [0, '10%'],
          // scale: true,
          ...yAxisConfig,
          axisLabel: {
            formatter: `{value}${qcType.unit}`,
            margin: 15,
            textStyle: {
              color: '#000'
            },
            fontFamily: 'Times New Roman'
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#D8E8FF'
            }
          }
        },
        series
      }

      this.chartWidth = factors.length > 0 ? `${factors.length * 15}px` : '100%'

      setTimeout(() => {
        chart.resize()
        chart.setOpt(chartOpt)
      }, 0)
    },
    readyRenderChart () {
      let {categories, data, realLimit} = this
      let refCharts = this.$refs.chart
      let {data: dataData, formatFactorMap} = data

      categories.forEach((categories, index) => {
        let renderData = {
          deviceId: data.deviceId,
          deviceName: data.deviceName,
          ts: data.ts
        }
        let markArea = {
          itemStyle: {
            color: 'rgba(0,0,0,0)'
          },
          label: {
            fontFamily: 'simsun'
          }
        }
        let splitLine = {}

        renderData.data = dataData

        if (categories.length === 0) {
          renderData.factors = Object.values(formatFactorMap)
        } else {
          let markAreaData = markArea.data = []
          splitLine.show = true

          let splitLineColors = []
          splitLine.lineStyle = {
            color: splitLineColors,
            type: 'dashed'
          }

          renderData.factors = categories.reduce((factors, category) => {
            let {list} = category
            markAreaData.push([{
              name: category.name,
              xAxis: list[0].name
            }, {
              xAxis: list[list.length - 1].name
            }])

            list.forEach((factor, index) => {
              splitLineColors.push(index === 0 ? '#000' : 'rgba(0,0,0,0)')
            })

            factors.push(...list)

            return factors
          }, [])
        }

        this.renderChart(renderData, refCharts[index], realLimit, {
          markArea,
          splitLine
        })
      })
    },
    onLimitChange () {
      this.realLimit = this.limit
      this.readyRenderChart()
    },
    onNotMatchBtnClick () {
      this.$emit('unmatched-btn-click')
    }
  },
  watch: {
    data: {
      handler (newVal) {
        let {data, qcType, chartType, factorGroupMap} = this
        let qcTypeChartType = qcType.chartType

        if (!chartType || (chartType !== 'boxplot' && chartType !== qcTypeChartType)) {
          this.chartType = qcTypeChartType
        }

        let qcTypeCategories = qcType.categories
        let {factorIds} = data
        let categories = []

        if (Array.isArray(qcTypeCategories)) {
          let {formatFactorMap} = data
          let {length} = factorIds
          let newFactorIds = []
          let half = Math.ceil(length / 2)
          newFactorIds.push(factorIds.slice(0, half))
          newFactorIds.push(factorIds.slice(half, length))

          categories = newFactorIds.map(factorIds => Object.values(factorIds.reduce((categoryMap, factorId) => {
            let formatFactor = formatFactorMap[factorId]
            let {parentId} = formatFactor
            let category = categoryMap[parentId]

            if (!category) {
              let factorGroup = factorGroupMap[parentId]
              category = categoryMap[parentId] = factorGroup ? {
                id: factorGroup.id,
                name: factorGroup.name,
                list: []
              } : {
                id: parentId,
                name: '未知分类',
                list: []
              }
            }

            category.list.push(formatFactor)

            return categoryMap
          }, {})))
        } else {
          categories.push([])
        }

        this.categories = Object.freeze(categories)

        this.realLimit = this.limit = qcType.defaultCtrlVal
        this.vShow = categories.map(() => true)
        setTimeout(this.readyRenderChart, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-item-header {
  display: grid;
  grid-template-columns: auto max-content;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0 10px;
  background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
  background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
  color: #ffffff;
  font-weight: 600;

  > .toolbar {
    display: flex;
    gap: 10px;
  }
}

.chart-wrapper {
  width: 100%;
  padding: 20px;

  .chart-wrapper-inner {
    width: 100%;
    overflow: auto;
  }

  .limit-input-wrapper {
    position: absolute;
    top: -10px;
    left: 0;
  }

  .summary-wrapper {
    font-size: .7em;
    line-height: 24px;
    user-select: all;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/00Data/QCChart.vue